// extracted by mini-css-extract-plugin
export default {"steps":"Steps_steps__4xAG+","step":"Steps_step__cHopC","stepIcon":"Steps_stepIcon__Z2jVN","stepTitle":"Steps_stepTitle__ws57o"};